import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useEstatisticasProducao } from "../context/EstatisticasProducaoContext";
import { producaoService } from "../../../../services/producaoService";

const EstatisticasPizzas: React.FC = () => {
  const { appliedFilters } = useEstatisticasProducao();

  const { data: tamanhos = [], isLoading } = useQuery({
    queryKey: ["tamanhos", appliedFilters],
    queryFn: () =>
      producaoService.getTamanhos({
        dataInicio: appliedFilters.dataInicio,
        dataFim: appliedFilters.dataFim,
        lojaId: appliedFilters.lojaId,
      }),
    enabled: !!(appliedFilters.dataInicio && appliedFilters.dataFim),
  });

  if (isLoading) {
    return (
      <div className="mt-6 rounded-lg bg-white shadow">
        <div className="border-b border-neutral-200 px-6 py-4">
          <h3 className="text-lg font-medium text-neutral-900">
            Quantidade produzida por tamanho
          </h3>
        </div>
        <div className="p-6">
          <div className="py-8 text-center text-neutral-500">Carregando...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 rounded-lg bg-white shadow">
      <div className="border-b border-neutral-200 px-6 py-4">
        <h3 className="text-lg font-medium text-neutral-900">
          Quantidade produzida por tamanho
        </h3>
      </div>
      <div className="p-6">
        {tamanhos.length === 0 ? (
          <div className="py-8 text-center text-neutral-500">
            Nenhum dado encontrado para o período selecionado.
          </div>
        ) : (
          <div className="space-y-4">
            {tamanhos.map((item) => (
              <div
                key={item.tamanho}
                className="rounded-lg border border-neutral-200 p-4 transition-shadow hover:shadow-md"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <span className="text-2xl">🍕</span>
                    <h4 className="text-lg font-semibold text-neutral-800">
                      {item.tamanho}
                    </h4>
                  </div>
                  <div className="text-2xl font-bold text-primary">
                    {item.quantidade}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EstatisticasPizzas;
